const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentListed } from './MomentListed';
import * as telegram from "./telegram"
import * as utils from "./utils"

export class Listings extends BaseObject {
  public account: Account = null
  public moments: MomentListed[] = null
  public valueFMV: number = null
  public costBasis: number = null
  public numMoments: number = null
  public computedDate: Date = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.account) this.account = new Account(this.account)
    if (this.moments) this.moments = this.moments.map((po) => new MomentListed(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }

  public isSafe(): boolean {
    return true
  }

  public getNiceGainString(): string {
    const numericalGain: number = this.valueFMV - this.costBasis
    const nice: string = `Unrealized ${ numericalGain < 0 ? 'loss of ' : 'gain of '}$${Math.round(Math.abs(numericalGain)).toLocaleString()}`
    return nice
  }
  public getGainClass(): string {
    if (this.valueFMV >= this.costBasis) return 'positive'
    return 'negative'
  }
  
}




(async () => {
})();
